import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function Footer() {
  const { t, localePath } = useI18n();
  return (
    <footer
      className="border-t border-slate-200 bg-[#0B2447] text-slate-200"
      data-testid="site-footer"
    >
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-4 lg:gap-16 lg:px-8">
        <div>
          <div className="flex items-center gap-2 font-serif text-xl">
            <span
              aria-hidden
              className="inline-block h-6 w-6 border-2 border-[#C56E4E]"
              style={{ transform: "rotate(45deg)" }}
            />
            <span className="uppercase tracking-[0.18em] text-white">Xorvyniq</span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-300">
            {t("footer.company_desc")}
          </p>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] text-[#C56E4E]">
            {t("footer.col_platform")}
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Link
                to={localePath("")}
                data-testid="footer-link-home"
                className="hover:text-white"
              >
                {t("nav.home")}
              </Link>
            </li>
            <li>
              <a href={localePath("") + "#sectors"} data-testid="footer-link-sectors" className="hover:text-white">
                {t("nav.sectors")}
              </a>
            </li>
            <li>
              <a href={localePath("") + "#process"} data-testid="footer-link-process" className="hover:text-white">
                {t("nav.process")}
              </a>
            </li>
            <li>
              <a href={localePath("") + "#newsletter"} data-testid="footer-link-newsletter" className="hover:text-white">
                {t("nav.newsletter")}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] text-[#C56E4E]">
            {t("footer.col_legal")}
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Link
                to={localePath("privacy")}
                data-testid="footer-link-privacy"
                className="hover:text-white"
              >
                {t("footer.link_privacy")}
              </Link>
            </li>
            <li>
              <Link
                to={localePath("cookies")}
                data-testid="footer-link-cookies"
                className="hover:text-white"
              >
                {t("footer.link_cookies")}
              </Link>
            </li>
            <li>
              <Link
                to={localePath("terms")}
                data-testid="footer-link-terms"
                className="hover:text-white"
              >
                {t("footer.link_terms")}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] text-[#C56E4E]">
            {t("footer.col_contact")}
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#C56E4E]" aria-hidden />
              <span>{t("footer.address_value")}</span>
            </li>
            <li className="flex gap-3">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-[#C56E4E]" aria-hidden />
              <a
                href={`mailto:${t("footer.email_value")}`}
                data-testid="footer-email-link"
                className="hover:text-white"
              >
                {t("footer.email_value")}
              </a>
            </li>
            <li className="flex gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[#C56E4E]" aria-hidden />
              <a
                href={`tel:${t("footer.phone_value").replace(/\s+/g, "")}`}
                data-testid="footer-phone-link"
                className="hover:text-white"
              >
                {t("footer.phone_value")}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1a2f4b]">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-400">
            {t("footer.legal_title")}
          </h4>
          <ul className="mt-3 grid gap-1.5 text-xs text-slate-400 sm:grid-cols-2 lg:grid-cols-3">
            <li>{t("footer.legal_company")}</li>
            <li>{t("footer.legal_cuit")}</li>
            <li>{t("footer.legal_iigj")}</li>
            <li>{t("footer.legal_license")}</li>
            <li>{t("footer.legal_jurisdiction")}</li>
            <li>{t("footer.legal_founded")}</li>
          </ul>
          <p className="mt-4 text-xs text-slate-500">{t("footer.disclaimer")}</p>
          <p className="mt-4 text-xs text-slate-500">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}
